import { createContext } from 'react'

const stripeSellerContext = createContext()

export default stripeSellerContext
